module.exports = __webpack_public_path__ + "img/stella_ceo.f954dd47.png";